import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';
import { Petition } from '../../../../../../../shared/admin-models/interfaces/petition.interface';

@Component({
  selector: 'app-executor-answer-dialog',
  templateUrl: './executor-answer-dialog.component.html',
  styleUrls: ['./executor-answer-dialog.component.scss']
})
export class ExecutorAnswerDialogComponent implements OnInit {
  comment: string = '';
  constructor(
    public dialogRef: MatDialogRef<ExecutorAnswerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { petition: Petition; mode: number },
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar
  ) {}
  closeDialog() {
    this.dialogRef.close();
  }
  ngOnInit() {}
  sendAnswer() {
    this._loadingService.register();
    if (!this.comment.length) return;
    const data = {
      petitionId: this.data.petition.id,
      isRealizable: this.data.mode,
      commentary: this.comment
    };
    this._adminService.sendExecutorAnswer(data).subscribe(
      (res) => {
        this._loadingService.resolve();
        this.dialogRef.close('სტატუსი წარმატებით შეიცვალა')
      },
      (err) => {
        this._loadingService.resolve()
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration:2000,
          panelClass:'red-snackbar',
          horizontalPosition:"right",
          verticalPosition:"top"
        })
      }
    );
  }
  get sendButtonColor() {
    if (this.comment.length && this.comment.length < 606) {
      return this.data.mode ? 'rgb(76,175,80)' : 'red';
    }
    return 'rgba(0,0,0,0.12)';
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/executor-answer-dialog/executor-answer-dialog.component.ts